import * as PROXY from '../../../common/api.js';
import * as PEGASUS from '@smatch/pegasus-api-docs';
import { CATEGORY_STORE, CATEGORY_HASH } from './store.js';
export * from './types.js';
/* eslint-disable arrow-body-style */
// Filter Categories
export const filterCategories = async (parameters = {}) => {
    return PROXY.handleFilter(PEGASUS.filterCategories, parameters)
        .then(categories => PROXY.updateStoreBulk(CATEGORY_STORE, categories));
};
// Fetch Category
export const fetchCategory = async (keys, onError) => {
    return PROXY.handleFetch(PEGASUS.fetchCategory, keys)
        .then(({ data, statusCode }) => {
        if (onError?.(statusCode) === true) {
            return {};
        }
        if (statusCode !== 'STATUS_200') {
            PROXY.handleApiError(statusCode);
            return {};
        }
        return PROXY.updateStore(CATEGORY_STORE, null, data);
    });
};
// Create Category
export const createCategory = async (body) => {
    return PROXY.handleCreate(PEGASUS.createCategory, body)
        .then(response => PROXY.updateStore(CATEGORY_STORE, CATEGORY_HASH, response));
};
// Update Category
export const updateCategory = async (keys, body) => {
    return PROXY.handleUpdate(PEGASUS.updateCategory, keys, body)
        .then(response => PROXY.updateStore(CATEGORY_STORE, CATEGORY_HASH, response));
};
// Delete Category
export const deleteCategory = async (keys) => {
    return PROXY.handleDelete(PEGASUS.deleteCategory, keys)
        .then(response => PROXY.removeFromStore(CATEGORY_STORE, CATEGORY_HASH, keys.categoryKey, response));
};
/* eslint-enable arrow-body-style */ 
